"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var ModuleHeader_1 = tslib_1.__importDefault(require("../moduleHeader/ModuleHeader"));
var BannerContent_1 = tslib_1.__importDefault(require("../_common/bannerContent/BannerContent"));
var BannerTimer_1 = tslib_1.__importDefault(require("../_common/BannerTimer"));
var theme_1 = require("../theme");
var WidgetContainer_1 = tslib_1.__importDefault(require("../_common/WidgetContainer"));
var BannerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    &.bannerModuleCarousel {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        overflow-y: hidden;\n        padding: 0 10px;\n    }\n\n    &.bannerModuleStrip {\n        margin: 0;\n        padding: 0;\n    }\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    &.bannerModuleCarousel {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        overflow-y: hidden;\n        padding: 0 10px;\n    }\n\n    &.bannerModuleStrip {\n        margin: 0;\n        padding: 0;\n    }\n"])));
var BannerContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    flex: 1;\n    box-sizing: border-box;\n\n    &.bannerModuleCarousel {\n        min-width: 100px;\n        padding: 5px;\n    }\n\n    &.bannerModuleStrip {\n        margin: 0;\n        padding: 0;\n    }\n\n    @media only screen and (max-width: 1199px) {\n        .splitBannerRow {\n            flex: 0 0 20% !important; /* TO OVERRIDE INLINE CSS */\n        }\n    }\n"], ["\n    flex: 1;\n    box-sizing: border-box;\n\n    &.bannerModuleCarousel {\n        min-width: 100px;\n        padding: 5px;\n    }\n\n    &.bannerModuleStrip {\n        margin: 0;\n        padding: 0;\n    }\n\n    @media only screen and (max-width: 1199px) {\n        .splitBannerRow {\n            flex: 0 0 20% !important; /* TO OVERRIDE INLINE CSS */\n        }\n    }\n"])));
var TimerContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var coordinates = _a.coordinates, position = _a.position;
    var style = 'position: absolute; pointer-events: none; direction: ltr;';
    switch (position) {
        case 'bottom-left':
            style += 'top: 80%; left: 3%; transform: translate(-3%, -80%);';
            break;
        case 'bottom-right':
            style += 'top: 80%; left: 95%; transform: translate(-95%, -80%);';
            break;
        case 'top-left':
            style += 'top: 5%; left: 3%; transform: translate(-3%, -5%);';
            break;
        case 'top-right':
            style += 'top: 5%; left: 95%; transform: translate(-95%, -5%);';
            break;
        case 'center':
            style += 'top: 50%; left: 50%; transform: translate(-50%, -50%);';
            break;
        case 'middle-right':
            style += 'top: 50%; left: 95%; transform: translate(-95%, -50%);';
            break;
        case 'middle-left':
            style += 'top: 50%; left: 5%; transform: translate(-5%, -50%);';
            break;
        case 'bottom-center':
            style += 'top: 80%; left: 50%; transform: translate(-50%, -80%);';
            break;
        case 'top-center':
            style += 'top: 5%; left: 50%; transform: translate(-50%, -5%);';
            break;
        default:
            break;
    }
    if (coordinates) {
        style += "left: " + coordinates.x + "; top: " + coordinates.y + "; transform: translate(-" + coordinates.x + ", -" + coordinates.y + ")";
    }
    return style;
});
var TimerInnerContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var bgColor = _a.bgColor, fontColor = _a.fontColor, imageUrl = _a.imageUrl;
    var style = "background-size: cover; color: " + theme_1.colors.bodyAlt + "; font-weight: bold; padding: 5px; font-size: 16px;";
    if (imageUrl) {
        style += "background: url(" + imageUrl + ") no-repeat 0 0;";
    }
    else {
        style += 'transparent';
    }
    if (bgColor) {
        style += "backgroundColor: " + bgColor;
    }
    else {
        style += "backgroundColor: #000";
    }
    if (fontColor) {
        style += "color: " + fontColor;
    }
    else {
        style += "color: #000";
    }
    return style;
});
var BannerModule = function (_a) {
    var adContext = _a.adContext, apiLocale = _a.apiLocale, cartContext = _a.cartContext, cdnTemplate = _a.cdnTemplate, isoLocale = _a.isoLocale, moduleData = _a.moduleData, tracking = _a.tracking;
    var banners = moduleData.banners, moduleHeader = moduleData.moduleHeader, numPerRow = moduleData.numPerRow, numPerView = moduleData.numPerView, textColor = moduleData.textColor, timer = moduleData.timer, type = moduleData.type;
    var innerSpacingValues = range_1.default(0, 20, 5);
    var bannerWrapper = {};
    var bannerContainer = {};
    // SET CUSTOM PADDING FOR STANDARD GRID BANNERS
    // DEFAULT 15px. ie: 3rd in innerSpacingValues
    var innerSpacing = moduleData && {}.hasOwnProperty.call(moduleData, 'innerSpacing') ? moduleData.innerSpacing : null;
    if (Number.isInteger(innerSpacing)) {
        var paddingPx = innerSpacing >= 0 && innerSpacing < 4
            ? innerSpacingValues[innerSpacing]
            : 15;
        bannerWrapper = {
            marginLeft: "-" + paddingPx + "px",
        };
    }
    var renderLabel = function () {
        if (!adContext || !moduleData.label || (moduleData.label && !moduleData.label.text)) {
            return null;
        }
        if (Array.isArray(moduleData.banners)) {
            var adBanners_1 = [];
            moduleData.banners
                .filter(function (banner) { return banner.slotId; })
                .forEach(function (banner) {
                adBanners_1.push(adContext.getUrl(banner.slotId));
            });
            adBanners_1 = adBanners_1.filter(function (v) { return v; });
            if (!adBanners_1.length) {
                return null;
            }
        }
        var labelStyles = tslib_1.__assign(tslib_1.__assign({ position: 'absolute', padding: '0 4px', fontSize: '1rem' }, get_1.default(moduleData, 'label.position', {})), { backgroundColor: get_1.default(moduleData, 'label.bgColor', '#fff'), color: get_1.default(moduleData, 'label.textColor', '#828282') });
        return (react_1.default.createElement("div", { style: tslib_1.__assign({}, labelStyles) },
            react_1.default.createElement("span", null, moduleData.label.text)));
    };
    return (react_1.default.createElement(WidgetContainer_1.default, { bgColor: moduleData.bgColor, bgImage: moduleData.bgImage },
        (moduleHeader === null || moduleHeader === void 0 ? void 0 : moduleHeader.titleText) && (react_1.default.createElement(ModuleHeader_1.default, { className: "siteWidthContainer", moduleData: moduleHeader, textColor: textColor })),
        react_1.default.createElement(BannerWrapper, { className: "siteWidthContainer " + type, style: bannerWrapper }, Array.isArray(banners) &&
            banners.map(function (banner, bIndex) {
                var perView = numPerRow || numPerView;
                var bannerClassList = typeof perView === 'number' && perView > 1 ? 'standardBanner' : 'featureBanner';
                var splitRow = perView === 10 && banner.titleText;
                var paddingBottom = '0px';
                if (perView &&
                    Number.isInteger(perView) &&
                    banners.length - perView > 0 &&
                    bIndex < banners.length - perView) {
                    bannerContainer = tslib_1.__assign(tslib_1.__assign({}, bannerContainer), { paddingBottom: '15px' });
                    paddingBottom = '15px';
                }
                return (react_1.default.createElement(BannerContainer, { key: banner.imagePath || banner.imageUrl, className: "bannerContainer " + type + " " + (splitRow ? 'splitBannerRow' : ''), style: perView
                        ? tslib_1.__assign(tslib_1.__assign({}, bannerContainer), { paddingBottom: paddingBottom, flex: "0 0 calc(" + (1 / perView) * 100 + "%" + (perView > 1 ? ' - 10px' : '') + ")" }) : {} },
                    react_1.default.createElement(BannerContent_1.default, { bannerStyle: type + " " + bannerClassList, bannerData: banner, cdnTemplate: cdnTemplate, tracking: tracking, isoLocale: isoLocale, apiLocale: apiLocale, adContext: adContext, cartContext: cartContext }),
                    timer && (react_1.default.createElement(TimerContainer, { coordinates: timer.coordinates, position: timer.position ? timer.position : 'bottom-right' },
                        react_1.default.createElement(TimerInnerContainer, { imageUrl: timer.imageUrl, bgColor: timer.bgColor, fontColor: timer.fontColor },
                            react_1.default.createElement(BannerTimer_1.default, { endTime: timer.expiry, disableDays: timer.disableDays ? timer.disableDays : false, displayUnitsBottom: timer.displayUnitsBottom ? timer.displayUnitsBottom : false, isSlider: false, timerFontSize: timer.fontSize ? timer.fontSize : '' }))))));
            })),
        renderLabel()));
};
exports.default = react_1.default.memo(BannerModule);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=BannerModule.js.map